import { Button, Signage } from '@kcd/design-system';

import { TrackPage } from '~/components/TrackEvent';
import { useGoHome } from '~/hooks/url';

const EmptyShowcase = () => {
  const goHome = useGoHome('replace');

  return (
    <>
      <TrackPage page="캐시노트마켓/offers/showcase/empty" />
      <Signage
        className="!mt-[50%]"
        title="기획전에 등록된 상품이 없습니다."
        action={
          <Button size="sm" variant="outline" onClick={goHome}>
            캐시노트마켓 홈으로 이동
          </Button>
        }
      />
    </>
  );
};

export default EmptyShowcase;
